import { FILTER_TYPES, LEVELS } from '../../../constants/TopFilterConstants';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../../hooks/searchParamHooks';
import UsageTracker from '../../../utils/UsageTracker';
import { Select } from 'foundations-components/components/Select';
import { FiltersWrapper } from './FiltersWrapper';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const getOptions = () => LEVELS.map(level => ({
  text: I18n.text(`learningCenter.topFilters.level.${level}`),
  value: level
}));
export const LevelFilter = ({
  appearsIn
}) => {
  const [level, setLevel] = useSearchParam(FILTER_TYPES.LEVEL);
  const handleLevelChange = selectedLevels => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: selectedLevels.length ? 'filter-selected' : 'filter-deselected',
      value: selectedLevels,
      isDropdown: true,
      key: 'level-filter',
      appearsIn
    });
    setLevel(selectedLevels);
  };
  return /*#__PURE__*/_jsx(FiltersWrapper, {
    children: /*#__PURE__*/_jsx(Select, {
      "aria-label": I18n.text('learningCenter.topFilters.level.filterTitle'),
      clearable: true,
      menuInlineSize: 200,
      multi: true,
      onSelectedOptionChange: evt => {
        handleLevelChange(evt.selectedValues);
      },
      options: getOptions(),
      selectedItemsPlaceholder: I18n.text('learningCenter.topFilters.level.filterTitle'),
      selectedValues: level
    })
  });
};